module.exports = __webpack_public_path__ + "static/media/lock.c8f5d62d.svg";